var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7112_21308",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7112_21308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.35 8.55078C14.15 8.05078 13.8542 7.65911 13.4625 7.37578C13.0709 7.09245 12.6 6.95078 12.05 6.95078C11.75 6.95078 11.4584 6.99245 11.175 7.07578C10.8917 7.15912 10.6334 7.31745 10.4 7.55078L8.95003 6.10078C9.18336 5.86745 9.50003 5.65495 9.90003 5.46328C10.3 5.27161 10.6667 5.15078 11 5.10078V3.00078H13V5.05078C13.75 5.20078 14.4084 5.50495 14.975 5.96328C15.5417 6.42162 15.9667 7.01745 16.25 7.75078L14.35 8.55078ZM19.8 22.6008L15.2 18.0008C14.95 18.2508 14.6084 18.4549 14.175 18.6133C13.7417 18.7716 13.35 18.8675 13 18.9008V21.0008H11V18.8508C10.0667 18.6174 9.28753 18.1924 8.66253 17.5758C8.03753 16.9591 7.58336 16.1841 7.30002 15.2508L9.30002 14.4508C9.50002 15.1508 9.83752 15.7508 10.3125 16.2508C10.7875 16.7508 11.4167 17.0008 12.2 17.0008C12.5 17.0008 12.775 16.9633 13.025 16.8883C13.275 16.8133 13.5167 16.7008 13.75 16.5508L1.40002 4.20078L2.80002 2.80078L21.2 21.2008L19.8 22.6008Z",
    fill: "#415364"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyOff);
export default __webpack_public_path__ + "static/media/money_off.4d5ea71e04283bb0bdd9880e2dea5932.svg";
export { ForwardRef as ReactComponent };